import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Avatar from "react-avatar";
import { BsCalendarDate } from "react-icons/bs";
import { FaUserMd, FaPrescription } from "react-icons/fa";
import { getRealtionshipTag } from "../../../../config/helpers/get-relationship-tags";
import { useNavigate } from "react-router";
import { FaLocationArrow } from "react-icons/fa";
import "../../../../styles/Rightsidebar.scss";
import { useModalMain } from "../../../../contexts/modal";
import InvoiceForm from "../../../../components/invoice/InvoiceForm";
import EvitalDuplicateResolution from "../../../../components/invoice/EvitalDuplicateResolution";
import { useAddModalMain } from "../../../../contexts/address-modal/AddModal";
import { request } from "../../../../config/helpers/axios-instance";
import { toast } from "react-toastify";
import { generateOcs } from "../../../../utils/ocs-generator";
import PartnerName from "../../../../components/partner/partner-name";
import { GetOrderDetailsByOrderId } from "../../../../hooks/fetch-hooks/order-details.js/get-order-details-by-id";
import { UpdateOrder } from "../../../../hooks/update-hooks/edit-order/order-data-update";
import { PREVENT_STATUS_UPDATE } from "../../constants";
import MutlipleAddressPrint from "../../../../components/address-print/multipleAddressPrint";
import { generateFiliaRxXml } from "../../../../utils/filiaRXGenerator";
import { userId, locationId } from "../../../../utils/filiaConstants";
import DeliveryCreateModal from "../../../../components/delivery/DeliveryCreateModal";
import OCSCreateModal from "../../../../components/ocs/OCSCreateModal";
import FiliaRxCreateModal from "../../../../components/filiaRX/FiliaRxCreateModal";
import { getTenantId } from "../../../../utils/helpers";
import { TENANT_COMPANY_MAP } from "../../../../utils/constants";
import PartnerAcko from "../../../../components/partner/partner-acko";
import { checkForShowMissingTimingsError } from "../../../../utils/orderUtils";
import { checkOcsReadiness } from "../../../../utils/ocsReadiness";
import OrderPackedButton from "../../../../components/order-packed/OrderPackedButton";
import PaymentInvoicesPrint from "../../../../components/PaymentsItemsTable/PaymentInvoicesPrint";
import {
    getMedicinePrintUrlsForOrder,
    getOrderMedicinePrintUrl,
    getServicePaymentItems,
    normalizePaymentItems,
} from "../../../../components/PaymentsItemsTable/printPaymentItemInvoices";
import AddressSlipSelectorModal from "../../../../components/address-print/AddressSlipSelectorModal";
import TransferPaymentsModal from "../transfer-payments-modal/TransferPaymentsModal";

function AllOrderDetailsRightBar({
    id,
    mapUserPatient: user,
    endDate,
    address,
    prescription,
    inventoryId
}) {
    const navigate = useNavigate();
    const { openModal } = useModalMain();
    const { AddopenModal, AddcloseModal } = useAddModalMain();
    const { data, isFetched, refetch } = GetOrderDetailsByOrderId(id);
    const [OrderData, setOrderdata] = useState({});
    const [invoicePrintPayload, setInvoicePrintPayload] = useState(null);
    const [showAddressSlipModal, setShowAddressSlipModal] = useState(false);
    const [showTransferPaymentsModal, setShowTransferPaymentsModal] = useState(false);
    const tenantId = getTenantId();

    useEffect(() => {
        setOrderdata(data?.data?.data);
    }, [data])


    const fetchBillNumber = async () => {
        try {
            const response = await request({
                method: "POST",
                url: `userOrder/admin/fetchBillNumber/${id}`,
            });
            if (response?.data?.success) {
                toast.success(`Bill number fetched: ${response.data.data.billNumber}`);
                refetch();
            } else {
                toast.error(response?.data?.err || "Failed to fetch bill number");
            }
        } catch {
            toast.error("Something went wrong");
        }
    };

    const UpdateEvital = async () => {
        const body = {
            userOrderId: id
        }

        if (tenantId === TENANT_COMPANY_MAP["EAZY"]) {
            body.hinaiInvoiceNo = inventoryId;
        } else {
            body.eVitalRXOrderNo = inventoryId;
        }

        const response = await request({
            method: "POST",
            url: tenantId === TENANT_COMPANY_MAP["EAZY"] ? `hinai/userorder` : `evitalrx/userorder`,
            data: body
        })

        const responseData = response?.data?.data;

        // Duplicate inventoryId items found -> let the user pick the right ones.
        if (response?.data?.success && responseData?.requiresResolution) {
            openModal(() => (
                <EvitalDuplicateResolution
                    duplicates={responseData.duplicates}
                    userOrderId={id}
                    eVitalRXOrderNo={inventoryId}
                    onSuccess={refetch}
                />
            ));
            return;
        }

        if (response?.data?.success) {
            toast.success("Request Successful");
        }
        if (!response?.data?.success) {
            toast.error("Somthing Went Wrong")
        }
    }
    if (!isFetched) {
        return (
            <></>
        )
    }

    const handleGenerateOcs = async (orderData, patientName, selection) => {
        if (!orderData || !patientName) {
            toast.error("Order data or patient name is not available")
            return
        }
        generateOcs(orderData, patientName, orderData.id, selection)
        if (!PREVENT_STATUS_UPDATE.includes(orderData.status)) {
            try {
                let response = await UpdateOrder({ status: 'OCS_PROCESSING' }, orderData.id);
                if (response.status === 200 && response?.data?.success) {
                    toast.success('Order status is changed to "OCS_PROCESSING"')
                }
                else {
                    toast.error(response?.data?.error || 'Order status is not updated!')
                }
            } catch (error) {
                toast.error('Something Went wrong. Please contact tech team!')
            }
        }
    }

    async function OcsClickHandler() {
        if (checkForShowMissingTimingsError(OrderData) && checkOcsReadiness(OrderData)) {
            AddopenModal(() => <OCSCreateModal handleGenerateOcs={handleGenerateOcs} orderData={OrderData} />)
        }
    }

    async function FiliaRXClickHandler(patientName) {
        generateFiliaRxXml(patientName, OrderData);
        if (!PREVENT_STATUS_UPDATE.includes(OrderData.status)) {
            try {
                let response = await UpdateOrder({ status: 'OCS_PROCESSING' }, id);
                if (response.status === 200 && response?.data?.success) {
                    toast.success('Order status is changed to "OCS_PROCESSING"')
                }
                else {
                    toast.error(response?.data?.error || 'Order status is not updated!')
                }
            } catch (error) {
                toast.error('Something Went wrong. Please contact tech team!')
            }
        }
    }

    async function FiliaRXRequestHandler(patientName) {
        let xml = generateFiliaRxXml(patientName, OrderData, false);

        try {
            const response = await fetch('http://localhost/FiliaRxInterfaceService.php', {
                method: 'POST',
                headers: {
                    'X-Filia-User-Id': userId,
                    'locationId': locationId,
                    'Content-Type': 'application/xml'
                },
                body: xml
            });

            if (response.ok) {
                await response.text();

                // Update order status if needed
                if (!PREVENT_STATUS_UPDATE.includes(OrderData.status)) {
                    let statusResponse = await UpdateOrder({ status: 'OCS_PROCESSING' }, id);
                    if (statusResponse.status === 200 && statusResponse?.data?.success) {
                        toast.success('Order status is changed to "OCS_PROCESSING"');
                    } else {
                        toast.error(statusResponse?.data?.error || 'Order status is not updated!');
                    }
                }
            } else {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        } catch (error) {
            console.error('FiliaRX Error:', error);
            toast.error('Failed to process FiliaRX request. Please contact tech team!');
        }
    }

    const filiaRXModal = async () => {
        AddopenModal(() => <FiliaRxCreateModal handleGenerateFiliaRX={FiliaRXClickHandler} orderData={OrderData} />)
    }

    const filiaRXRequestModal = async () => {
        AddopenModal(() => <FiliaRxCreateModal handleGenerateFiliaRX={FiliaRXRequestHandler} orderData={OrderData} />)
    }

    const hasOrderAddressForDelivery = () => {
        const addressId = parseInt(OrderData?.addressId);
        return Boolean(addressId) && addressId > 0 && address;
    };

    const handleDelivery = async () => {
        if (!hasOrderAddressForDelivery()) {
            toast.error("Address is not available");
            return;
        }

        AddopenModal(() => <DeliveryCreateModal orderId={parseInt(id)} mapUserPatient={user} address={address} onClose={AddcloseModal} orderData={OrderData} />)
    }

    const handlePrintAllInvoices = async (override) => {
        let orderDetails = OrderData;

        try {
            const response = await request({
                url: `userOrder/admin/orderDetails/${id}`,
                method: 'GET',
            });
            if (response?.data?.data) {
                orderDetails = response.data.data;
                setOrderdata(orderDetails);
            }
        } catch {
            toast.error('Could not load order details for printing');
            return;
        }

        const paymentItems = normalizePaymentItems(orderDetails?.paymentItems);
        const medicinePrintUrls = getMedicinePrintUrlsForOrder(paymentItems, orderDetails);
        const serviceItems = getServicePaymentItems(paymentItems);
        const hasAddress = Boolean(address || orderDetails?.address);

        if (!medicinePrintUrls.length && !serviceItems.length && !hasAddress) {
            toast.warn(
                orderDetails?.inventoryId && !getOrderMedicinePrintUrl(orderDetails)
                    ? 'Medicine invoice print URL is not available for this order'
                    : 'Nothing available to print for this order'
            );
            return;
        }

        if (!hasAddress) {
            toast.warn('Address not available — invoices will print without the shipping label');
        }

        const printAddress = address || orderDetails?.address;

        setInvoicePrintPayload({
            paymentItems,
            sourceData: orderDetails,
            addressPrint: printAddress
                ? {
                    address: { ...printAddress, name: override?.name, phone: override?.phone },
                    orderId: id,
                    billNo: orderDetails?.additionalDetails?.billNumber ?? null,
                    mapUserPatient: null,
                }
                : null,
        });
    }

    const printMultipleAddress = () => {
        let addresses = [];
        addresses.push({ address: address, orderId: id, bill_no: OrderData?.additionalDetails?.billNumber ?? null })
        AddopenModal(() => MutlipleAddressPrint({ addresses, selectedRows: [OrderData] }))
    }

    async function handleCreateAndSendConsent(orderId) {
        if (parseInt(OrderData?.addressId) === 0 && !OrderData?.address) {
            toast.error("Address is not available")
            return
        }

        try {
            const res = await request({
                url: `userOrder/admin/generateAndSendConsentJourneyURL`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    orderId
                }
            })

            if (res && res.data.success) {
                toast.success("Consent URL sent successfully!")
            } else {
                toast.warn("Error sending consent URL!")
            }
        } catch (error) {
            toast.warn("Something went wrong!")
        }
    }

    return (

        <div
            id="rightbar"
            className="mt-4"
        >
            {/* USER DETAILS */}
            <div className="flex items-center gap-4 p-4 rounded-2xl">
                <Avatar
                    size="75"
                    facebook-id="invalidfacebookusername"
                    src="https://static.vecteezy.com/system/resources/previews/007/224/856/original/flat-doctor-avatar-for-website-chat-window-vector.jpg"
                    name={user?.User?.name}
                    round="50%"
                />
                <div className="CardTextDiv">
                    <h1 className="font-bold text-xl font-sans">{user?.Patient?.name}</h1>
                    <div className="flex items-center gap-2">
                        <h3 className="font-bold text-xs p-1 font-sans text-[blue] border rounded-2xl border-[#158D7B]">
                            {getRealtionshipTag(user?.relationship)}
                        </h3>
                        <h2 className="font-semibold text-md font-sans rel my-2">
                            {user?.User?.name === user?.Patient?.name
                                ? "Self"
                                : user?.User?.name}
                        </h2>
                    </div>
                </div>
            </div>

            <div className="flex mt-2 p-4 items-center gap-2 text-divs">
                <h3>
                    <FaLocationArrow fontSize={"1.7rem"} id="location" />
                </h3>
                <p>
                    {address ?
                        `${address?.line} ${address?.district}, ${address?.state}` : "Not available"}
                </p>
            </div>
            <div className="flex p-4 py-1 items-center gap-2 text-divs">
                <h3>
                    <BsCalendarDate fontSize={"1.7rem"} id="location" />
                </h3>
                <div>
                    <p className="text-xs font-sans">Order EndDate</p>
                    <p className="text-sm font-bold font-sans">
                        {endDate && endDate.split("T")[0]}
                    </p>
                </div>
            </div>
            <div className="flex mt-2 px-4 py-2 items-center gap-2 text-divs">
                <h3 className="font-sans">
                    <FaUserMd fontSize={"1.5rem"} id="location" />
                </h3>

                <p>{prescription ? prescription?.drName : "Not Available"}</p>
            </div>
            <div className="flex mt-2 px-4 py-2 items-center gap-2 text-divs">
                <h3 className="font-sans">
                    <FaPrescription fontSize={"1.5rem"} id="location" />
                </h3>
                <p>{id}</p>
            </div>

            {/* ACTIONS */}
            <div className="flex gap-2 mt-4 px-4 flex-wrap actions">
                <button
                    id="button"
                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#001524] text-white-50"
                    onClick={() => {
                        if (checkForShowMissingTimingsError(OrderData, navigate)) {
                            navigate(`/drx/${id}`, { replace: true })
                        }
                    }}>
                    DRX
                </button>
                <button
                    id="button"
                    onClick={() => {
                        if (checkForShowMissingTimingsError(OrderData, navigate, false)) {
                            navigate(`/drx/${id}?batch=true`, { replace: true })
                        }
                    }}
                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#0a9396] text-white-50 prx">
                    WO B.No
                </button>
                {
                    tenantId != TENANT_COMPANY_MAP["EAZY"] && <>
                        {
                            !inventoryId ?
                                <button
                                    id="button"
                                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#e71d36] text-white-50" onClick={() => openModal(() => InvoiceForm(id))}>
                                    Map Evital
                                </button> :
                                <button id="button"
                                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#e71d36] text-white-50" onClick={UpdateEvital}>
                                    Update Evital
                                </button>
                        }
                    </>
                }
                {
                    tenantId === TENANT_COMPANY_MAP["EAZY"] && <>
                        {
                            !inventoryId ?
                                <button
                                    id="button"
                                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#e71d36] text-white-50" onClick={() => openModal(() => InvoiceForm(id))}>
                                    Map Hinai
                                </button> :
                                <button id="button"
                                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#e71d36] text-white-50" onClick={UpdateEvital}>
                                    Update Hinai
                                </button>
                        }
                    </>
                }
                {
                    tenantId === TENANT_COMPANY_MAP["PILLUP"] && inventoryId &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#6c757d] text-white-50"
                        onClick={async () => {
                            if (!window.confirm(`Are you sure you want to unmap Evital (${inventoryId}) from this order? This cannot be undone.`)) return;
                            try {
                                const response = await request({
                                    method: "PUT",
                                    url: `userOrder/admin/unmapInventory/${id}`,
                                });
                                if (response?.data?.success) {
                                    toast.success("Evital unmapped successfully");
                                    refetch();
                                } else {
                                    toast.error(response?.data?.err || "Failed to unmap Evital");
                                }
                            } catch {
                                toast.error("Something went wrong");
                            }
                        }}>
                        Unmap Evital
                    </button>
                }
                {
                    tenantId !== TENANT_COMPANY_MAP["EAZY"] && inventoryId && !OrderData?.additionalDetails?.billNumber &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#f4a261] text-white-50"
                        onClick={fetchBillNumber}>
                        Fetch Bill Number from Evital
                    </button>
                }
                {
                    address &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[blue] text-white-50" onClick={() => printMultipleAddress()}>
                        Print Address
                    </button>
                }
                {OrderData?.prescription && <button
                    id="button"
                    className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50" onClick={() => OcsClickHandler()}>
                    OCS
                </button>}
                {
                    OrderData?.prescription
                    &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50" onClick={() => {
                            if (checkForShowMissingTimingsError(OrderData)) {
                                AddopenModal(() => PartnerName(OrderData, AddcloseModal))
                            }
                        }}>
                        OCS with Partner
                    </button>
                }
                {
                    OrderData?.prescription
                    &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-green-400 text-white-50" onClick={() => {
                            if (checkForShowMissingTimingsError(OrderData)) {
                                AddopenModal(() => PartnerAcko(OrderData, AddcloseModal))
                            }
                        }}>
                        Acko OCS
                    </button>
                }
                {
                    tenantId === TENANT_COMPANY_MAP["EAZY"] && OrderData?.prescription
                    &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50" onClick={() => filiaRXModal()}>
                        FRX
                    </button>
                }
                {
                    tenantId === TENANT_COMPANY_MAP["EAZY"] && OrderData?.prescription
                    &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50" onClick={() => filiaRXRequestModal()}>
                        FRX Request
                    </button>
                }
                {
                    OrderData?.prescription
                    && hasOrderAddressForDelivery()
                    &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50" onClick={() => handleDelivery()}>
                        Delivery
                    </button>
                }
                {
                    tenantId !== TENANT_COMPANY_MAP["EAZY"]
                    &&
                    <button
                        id="button"
                        type="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#0a9396] text-white-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => setShowAddressSlipModal(true)}
                        disabled={!isFetched}
                    >
                        Print Invoices
                    </button>
                }
                {showAddressSlipModal && (
                    <AddressSlipSelectorModal
                        userName={user?.User?.name || ''}
                        userPhone={user?.User?.contact_no || ''}
                        patientName={user?.Patient?.name || ''}
                        patientPhone={user?.Patient?.contact_no || ''}
                        onConfirm={(override) => {
                            setShowAddressSlipModal(false);
                            handlePrintAllInvoices(override);
                        }}
                        onClose={() => setShowAddressSlipModal(false)}
                    />
                )}
                {
                    OrderData?.inventoryId
                    &&
                    <button
                        id="button"
                        className={`p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#902b8b] text-white-50 ${OrderData?.consentDetails ? 'bg-gray-400' : ''}`} onClick={() => handleCreateAndSendConsent(OrderData?.id)}
                        disabled={OrderData?.consentDetails}
                    >
                        {OrderData?.consentDetails ? 'Consent Accepted' : 'Create & Send Consent'}
                    </button>
                }
                {
                    OrderData?.inventoryId && <OrderPackedButton orderId={OrderData?.id} />
                }
                {
                    tenantId === TENANT_COMPANY_MAP["PILLUP"] &&
                    <button
                        id="button"
                        className="p-3 text-lg px-7 font-medium font-sans shadow-soft-xl rounded-2xl bg-[#001524] text-white-50"
                        onClick={() => setShowTransferPaymentsModal(true)}>
                        Fetch Payments
                    </button>
                }
            </div>
            {showTransferPaymentsModal && (
                <TransferPaymentsModal
                    targetOrderId={parseInt(id)}
                    onSuccess={refetch}
                    onClose={() => setShowTransferPaymentsModal(false)}
                />
            )}
            {invoicePrintPayload && (
                <PaymentInvoicesPrint
                    paymentItems={invoicePrintPayload.paymentItems}
                    sourceData={invoicePrintPayload.sourceData}
                    addressPrint={invoicePrintPayload.addressPrint}
                    onDone={() => setInvoicePrintPayload(null)}
                />
            )}
        </div>
    );
}

AllOrderDetailsRightBar.propTypes = {
    mapUserPatient: PropTypes.object,
    address: PropTypes.object,
    prescription: PropTypes.object,
    endDate: PropTypes.string,
    id: PropTypes.any,
    noOfDays: PropTypes.number,
    userMappingId: PropTypes.string,
    transactionId: PropTypes.string,
    addressId: PropTypes.string,
    prescriptionId: PropTypes.string,
    status: PropTypes.string,
    notes: PropTypes.string,
    inventoryId: PropTypes.string,
    Partner: PropTypes.string
};

export default AllOrderDetailsRightBar;
